import BaseModel from "../api/models/BaseModel";

/**
 * CollectionItem
 * This class is an item object from Collection
 */
export default class CollectionItem extends BaseModel{

    /**
     * Construct this collectionItem with sent parameters
     * @param {*} index - key or index of this item
     * @param {*} val - value of item
     */
    constructor(index = null, val = null) {
        super();
        this.index = index;
        this.value = val;
    }

    /**
     * Gets the 'index' attribute
     * @returns {*}
     */
    getIndex() {
        return this.index;
    }

    /**
     * Gets the 'value' attribute
     * @returns {*}
     */
    getValue() {
        return this.value;
    }

    /**
     * Check if sent value is the same
     * @param {*} val
     * @returns {boolean}
     */
    isValue(value = null) {
        return this.getValue() != undefined && this.getValue() == value ? true : false; 
    }
}